import SimpleTranslateButton from './SimpleTranslateButton';

export default SimpleTranslateButton;
